module.exports = __webpack_public_path__ + "static/img/icon-cart-n.fceb7c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/view/shopping/images/icon-cart-n.png
// module id = XIyO
// module chunks = 21